import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import moment from 'moment-jalaali'
import Chip from "@mui/material/Chip";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CreateIcon from "@mui/icons-material/Create";
import {Head, TicketChangeCategory} from "../../../components";
import Api from "../../../utils/api";
import {itemProductAction} from "../../../actions";
import ItemProductChangeOrder from "../../../components/Product/ItemProduct/changeOrder";

const ItemProduct = ( props ) => {

    const { fetchItemProduct, itemProductReducer } = props;

    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');



    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type]);


    const handleRequest = () => {
        fetchItemProduct({
            form:"item_product_admin",
            type:null,
            sort_type:null
        })
    };



    const handleChangeStatus = (id, field) => {
        new Api().put('/products/itemProduct/' + id + '/status', {field}).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }



    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'محصولات آیتمی', 'description': 'محصولات صفحه نخست سایت را به صورت دلخواه انتخاب کنید' }} />
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="افزودن">
                    <Link to={'/product/item/create'}>
                        <IconButton>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Link>
                </Tooltip>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => {setSortField('id'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('title'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>عنوان&nbsp;{sort_field === 'title' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('created_by'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>کاربر&nbsp;{sort_field === 'created_by' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th>تعداد محصولات</th>
                            <th onClick={() => {setSortField('order'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>مرتب سازی&nbsp;{sort_field === 'order' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th onClick={() => {setSortField('status'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th onClick={() => {setSortField('updated_at'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>به روز رسانی&nbsp;{sort_field === 'updated_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {itemProductReducer.entities.data && itemProductReducer.entities.data.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity.id}</td>
                                    <td>{entity.title}</td>
                                    <td>{entity.created_by && entity.created_by.name}</td>
                                    <td>{entity.products.length}</td>
                                    <td><ItemProductChangeOrder reload={() => handleRequest()} entity={entity} /></td>
                                    <td>
                                        <Tooltip title="وضعیت">
                                            <Chip size={"small"} variant={"outlined"} color={+entity.status ? "primary": "secondary"}  label={+entity.status ? 'فعال' : 'غیرفعال'} clickable={true} onClick={() => handleChangeStatus(entity.id, 'status')} />
                                        </Tooltip>
                                    </td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.created_at, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <Tooltip title="ویرایش">
                                            <Link to={`/product/item/${entity.id}/edit`}>
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </>
        </Container>
    );
}


const mapStateToProps = state => ({
    itemProductReducer: state.itemProductReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchItemProduct: (object) => {
        dispatch(itemProductAction.fetchItemProduct(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemProduct)
